<template>

    <div>
        <div class="modal fade" id="documentConnectionsModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Koppelen</h4>
                    </div>
                    <div class="modal-body text-center">
                        <div class="btn-group">
                            <div
                                class="btn btn-primary"
                                @click="openCrmSelector"
                                v-if="crm === true"
                            >Contact/Bedrijf</div>
                            <div
                                class="btn btn-success"
                                @click="openOfficeSelector"
                                v-if="users === true"
                            >Medewerker</div>
                            <div
                                class="btn btn-info"
                                @click="openProjectSelector"
                                v-if="projects === true"
                            >Project</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <crm-selector
            v-if="crm === true"
            ref="dcCrmSelector"
            :on-selected="crmSelect"
        ></crm-selector>
        <office-selector
            v-if="users === true"
            ref="dcOfficeSelector"
            @selected-users="selectedUsers"
        ></office-selector>
        <project-selector
            v-if="projects === true"
            ref="dcProjectSelector"
            :on-selected="projectSelect"
        ></project-selector>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import CrmSelector from "../Common/Selectors/CrmSelector";
import OfficeSelector from "../Common/Selectors/OfficeSelector";
import ProjectSelector from "../Common/Selectors/ProjectSelector";

export default {

    components:{
        ProjectSelector,
        OfficeSelector,
        CrmSelector,
    },

    computed:{

        ...mapGetters([
            'getOfficeUsers',
        ]),

    },

    methods: {

        crmSelect(contact){
            this.sendConnection("crm", contact.uuid, this.getCrmName(contact));
            this.$refs.dcCrmSelector.closeSelector();
            this.close();
        },

        selectedUsers(users) {
            users.forEach(user => this.sendConnection("user", user, this.getOfficeUsers.filter(usr => usr.uuid === user)[0].fullname));
            this.close();
        },

        projectSelect(project){
            this.sendConnection("project", project.uuid, project.number + " - " + project.name);
            this.$refs.dcProjectSelector.closeSelector();
            this.close();
        },

        close() {
            // Hide the modal
            $('#documentConnectionsModal').modal('hide');
        },

        getCrmName(contact){
            if (contact.isContact === false) {
                return contact.company_name;
            }
            if (contact.company_name === null || contact.company_name === "") {
                return contact.full_name;
            }
            return contact.full_name + " (" + contact.company_name + ")";
        },

        open() {
            $('#documentConnectionsModal').modal('show');
        },

        openCrmSelector() {
            this.$refs.dcCrmSelector.openSelector();
        },

        openProjectSelector() {
            this.$refs.dcProjectSelector.openSelector();
        },

        openOfficeSelector() {
            this.$refs.dcOfficeSelector.openOfficeSearch();
        },

        sendConnection(connectionname, id, name) {
            this.$emit("add-connection",{
                connection:connectionname,
                id:id,
                name:name,
            });
        }

    },

    name:"DocumentsConnections",

    props: {
        crm: {
            type:Boolean,
            default:true,
        },
        users: {
            type:Boolean,
            default:true,
        },
        projects: {
            type:Boolean,
            default:true,
        },
    },

}

</script>
